import * as actionTypes from './types';

const inituelState = {
    loading: false,
    error: false,
    
    countries: null
};
const countryReducer = (state = { ...inituelState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.REQUST_COUNTRY:
            return {
                ...state,
                loading: true
            };
        case actionTypes.FAILED_COUNTRY:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case actionTypes.SUCCESS_COUNTRY:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false
            };

      
        default:
            return {
                ...state
            };
    }
};

export default countryReducer;
